// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'objektiv', 'objektiv Fallback', Objektiv, sans-serif"},"className":"__className_ddeaa7","variable":"__variable_ddeaa7"};